function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useGlobalValue } from '../../../state/GlobalProvider';
import Icon from '../../Icon/Icon';
import styles from './FloatButton.module.sass';

const FloatButton = props => {
  const {
    className,
    offset,
    icon,
    ...attributes
  } = props;
  const {
    theme
  } = useGlobalValue();
  const headerHeight = parseInt(((theme || {}).layout || {}).$headerHeight || '0', 10);
  const buttonIcon = icon ? /*#__PURE__*/React.createElement(Icon, {
    className: styles['icon'],
    name: icon
  }) : null;
  return /*#__PURE__*/React.createElement("button", _extends({
    style: offset ? {
      top: `${headerHeight + offset}px`
    } : null,
    className: `${styles['button']} ${className || ''}`
  }, attributes), buttonIcon);
};

export default FloatButton;